import { identity, isDevelopment } from './utils';
import { withContext } from './withContext';
export function withFilters(filters) {
    if (!Array.isArray(filters)) {
        if (isDevelopment()) {
            throw TypeError("'filters' should be an array");
        }
        return identity;
    }
    var filteredFilters = filters.filter(function (x) { return x && typeof x === 'function'; });
    return withContext({ Filters: filteredFilters });
}
//# sourceMappingURL=withFilters.js.map